module.exports = __webpack_public_path__ + "static/undraw_bug_fixing-aef16816ce8305817d34f971be725308.svg";